
import { ObtenerFechaFromIsoFormat } from 'functions/DatesFunctions';
import { getTdTableStyles } from 'helpers/Table/tableFunctions';
import React from 'react';
import { useTable, Column, Accessor, HeaderGroup, useGlobalFilter, usePagination, useSortBy, useRowSelect } from "react-table";
import { Container, Table, Row, Col, Label, Input, Button } from 'reactstrap'

import "../../..../../../../assets/scss/TablaAprobacionSolicitudesMasivas.scss";

import PdfSVG from "assets/icons/Permisos/PDF(azul).svg"
import AnularSVG from "assets/icons/Permisos/anularXazul.svg"
import EditarSVG from "assets/icons/Permisos/editarAzul.svg"
import { EstadoSolicitudPermisos } from '../../../DirectivoUnidad/AprobacionSolicitudes/TypesAprobacionSolicitudes';
import { CustomStyleColumn } from '../../../Types/GeneralTypes';
import 'assets/scss/SolicitudesPermisos.scss'

export default function TableSolicitudesPermisosIngresados({ dataprops, datapropsCH, datapropsL, datapropsV, onClickVerDocumento, onClickAnularSolicitud, onClickEditarSolicitud, onClickAnularSolicitudCH }) {




    const filas = React.useMemo(() => {
        const dataWithSourceA = dataprops.map(item => ({ ...item, source: 'dataprops' }));
        const dataWithSourceB = datapropsCH.map(item => ({ ...item, source: 'datapropsCH' }));
        const dataWithSourceC = datapropsL.map(item => ({ ...item, source: 'datapropsL' }));
        const dataWithSourceD= datapropsV.map(item => ({ ...item, source: 'datapropsV' }));
        return [...dataWithSourceA, ...dataWithSourceB, ...dataWithSourceC, ...dataWithSourceD];
    }, [dataprops, datapropsCH, datapropsL, datapropsV]);


    function GenerarCellAcciones(data) {
       

        const iconoEditarSolicitud = (
            <i
                data-toggle="tooltip" data-placement="top" title="Editar Solicitud" onClick={() => onClickEditarSolicitud(data)}
            >
                <img
                    src={EditarSVG} // Cambia la ruta al lugar donde esté almacenado tu SVG
                    className="acciones"
                    alt="Editar Solicitud"
                    data-toggle="tooltip"
                    data-placement="top"
                    title="Editar Solicitud"
                    style={{ width: 24, height: 24 }} // Ajusta el tamaño según necesites
                />
            </i>
        )

        if (data.source === 'dataprops') {
            

            const iconoAnularSolicitud = (
                <i
                    data-toggle="tooltip" data-placement="top" title="Anular Solicitud"
                    onClick={() => onClickAnularSolicitud(data)}
                >
                    <img
                        src={AnularSVG} // Cambia la ruta al lugar donde esté almacenado tu SVG
                        className="acciones"
                        alt="Anular Solicitud"
                        data-toggle="tooltip"
                        data-placement="top"
                        title="Anular Solicitud"
                        style={{ width: 24, height: 24 }} // Ajusta el tamaño según necesites
                    />
                </i>
            )

            const contentAccion = (
                <React.Fragment>
                    
                    {(data.estadoPermiso == EstadoSolicitudPermisos.NOTIFICADO || data.estadoPermiso == EstadoSolicitudPermisos.RECHAZADOPARCIALUATH) && (data.tipoPermiso != 5) && iconoEditarSolicitud}
                    {(data.estadoPermiso == EstadoSolicitudPermisos.INGRESADO || data.estadoPermiso == EstadoSolicitudPermisos.NOTIFICADO /*|| (data.estadoPermiso == EstadoSolicitudPermisos.REVISADODIRECTIVO && data.tipoPermiso == 18)*/) && (data.tipoPermiso != 5) && iconoAnularSolicitud}

                </React.Fragment>
            )
            return contentAccion
        } else if (data.source === 'datapropsCH') {
            const iconoAnularSolicitud = (
                <i
                    data-toggle="tooltip" data-placement="top" title="Anular Solicitud"
                    onClick={() => onClickAnularSolicitudCH(data)}
                >
                    <img
                        src={AnularSVG} // Cambia la ruta al lugar donde esté almacenado tu SVG
                        className="acciones"
                        alt="Anular Solicitud"
                        data-toggle="tooltip"
                        data-placement="top"
                        title="Anular Solicitud"
                        style={{ width: 24, height: 24 }} // Ajusta el tamaño según necesites
                    />
                </i>
            )

            const contentAccion = (
                <React.Fragment>
                    {(data.estadoPermiso == EstadoSolicitudPermisos.INGRESADO) && iconoAnularSolicitud}
                </React.Fragment>
            )
            return contentAccion
        } else if (data.source === 'datapropsL') {
            const iconoAnularSolicitud = (
                <i
                    data-toggle="tooltip" data-placement="top" title="Anular Solicitud"
                    onClick={() => onClickAnularSolicitud(data)}
                >
                    <img
                        src={AnularSVG} // Cambia la ruta al lugar donde esté almacenado tu SVG
                        className="acciones"
                        alt="Anular Solicitud"
                        data-toggle="tooltip"
                        data-placement="top"
                        title="Anular Solicitud"
                        style={{ width: 24, height: 24 }} // Ajusta el tamaño según necesites
                    />
                </i>
            )

            const contentAccion = (
                <React.Fragment>
                    {(data.estadoPermiso == EstadoSolicitudPermisos.NOTIFICADO ||data.estadoPermiso == EstadoSolicitudPermisos.RECHAZADOPARCIALUATH) && (data.certificadoValidado !== "E")&& iconoEditarSolicitud}
                    {(data.estadoPermiso == EstadoSolicitudPermisos.INGRESADO || data.estadoPermiso == EstadoSolicitudPermisos.REVISADODIRECTIVO || data.estadoPermiso == EstadoSolicitudPermisos.NOTIFICADO) && iconoAnularSolicitud}
                </React.Fragment>
            )
            return contentAccion
        }
        return null
    }

    function GenerarCellDocumentos(data) {
        const iconoDescargarSolicitud = (
            <i
                data-toggle="tooltip" data-placement="top" title="Descargar Solicitud"
                onClick={() => onClickVerDocumento(data.refArchivoPermiso)}
            >
                <img
                    src={PdfSVG} // Cambia la ruta al lugar donde esté almacenado tu SVG
                    className="acciones"
                    alt="Descargar Solicitud"
                    data-toggle="tooltip"
                    data-placement="top"
                    title="Descargar Solicitud"
                    style={{ width: 24, height: 24 }} // Ajusta el tamaño según necesites
                />
            </i>
        )

        const iconoDescargarEvidencia = (
            <i
                data-toggle="tooltip" data-placement="top" title="Descargar Evidencia"
                onClick={() => onClickVerDocumento(data.refArchivoCertMedico)}
            >
                <img
                    src={PdfSVG} // Cambia la ruta al lugar donde esté almacenado tu SVG
                    className="acciones"
                    alt="Descargar Evidencia"
                    data-toggle="tooltip"
                    data-placement="top"
                    title="Descargar Evidencia"
                    style={{ width: 24, height: 24 }} // Ajusta el tamaño según necesites
                />
            </i>
        )

        const iconoDescargarProgCita = (
            <i
                data-toggle="tooltip" data-placement="top" title="Descargar Programación Cita"
                onClick={() => onClickVerDocumento(data.refArchivoProgCita)}
            >
                <img
                    src={PdfSVG} // Cambia la ruta al lugar donde esté almacenado tu SVG
                    className="acciones"
                    alt="Descargar Programación Cita"
                    data-toggle="tooltip"
                    data-placement="top"
                    title="Descargar Programación Cita"
                    style={{ width: 24, height: 24 }} // Ajusta el tamaño según necesites
                />
            </i>
        )


        if (data.source === 'dataprops') {
            


            const contentAccion = (
                <React.Fragment>
                    {data.refArchivoProgCita && iconoDescargarProgCita}
                    {data.refArchivoCertMedico && iconoDescargarEvidencia}
                    {data.refArchivoPermiso && iconoDescargarSolicitud}
                </React.Fragment>
            )
            return contentAccion
        } else if (data.source === 'datapropsCH') {
           
            const contentAccion = (
                <React.Fragment>
                    {data.refArchivoPermiso && iconoDescargarSolicitud}
                </React.Fragment>
            )
            return contentAccion
        } else if (data.source === 'datapropsL') {
            

            const contentAccion = (
                <React.Fragment>
                    {data.refArchivoCertMedico && iconoDescargarEvidencia}
                    {data.refArchivoPermiso && iconoDescargarSolicitud}
                </React.Fragment>
            )
            return contentAccion
        }  else if (data.source === 'datapropsV') {
            
            const esvacacionxresolucion = data.esxresolucion == "S" && data.nrodocautorizacion != null;
            const contentAccion = (
                <React.Fragment>
                    {data.refArchivoPermiso && !esvacacionxresolucion && iconoDescargarSolicitud}
                </React.Fragment>
            )
            return contentAccion
        }
        return null
    }
    const columnas: any = React.useMemo(
        () => [
            {
                Header: 'Fecha Solicitud',
                accessor: 'fechaSolicitud',
                Cell: ({ value }) => ObtenerFechaFromIsoFormat(value),
                style: { textAlign: 'center' },
            },
            {
                Header: 'Tipo Permiso / Licencia',
                accessor: 'strTipoPermiso',
            },
            {
                Header: 'Fecha Desde',
                accessor: 'fechaDesde',
                Cell: ({ value }) => ObtenerFechaFromIsoFormat(value),
                style: { textAlign: 'center' },
            },
            {
                Header: 'Fecha Hasta',
                accessor: row => row.fechaVigHasta ?? row.fechaHasta, // Prioriza fechaVigHasta
                Cell: ({ value }) => value ? ObtenerFechaFromIsoFormat(value) : "", // Maneja null/undefined
                style: { textAlign: 'center' }
            },
            {
                Header: 'Horario',
                id: 'horas',
                accessor: row => ({
                    horaInicio: row.horaInicio ?? row.horaDesde,
                    horaFin: row.horaFin ?? row.horaHasta,
                    horaInicioTarde: row.horaInicioTarde ?? row.horaDesdeTarde,
                    horaFinTarde: row.horaFinTarde ?? row.horaHastaTarde
                }),
                Cell: ({ value }) => (
                    <div className="horario-compacto">
                        <div className="linea-horario">
                            {value.horaInicio && value.horaFin && (
                                <span>{value.horaInicio} - {value.horaFin}</span>
                            )}
                        </div>
                        {value.horaInicioTarde && value.horaFinTarde && (
                            <div className="linea-horario">
                                <span>{value.horaInicioTarde} - {value.horaFinTarde}</span>
                            </div>
                        )}
                    </div>
                ),
                minWidth: 120 // Ancho mínimo sugerido
            },
            {
                Header: 'Días Solicitados',
                accessor: 'diasSolicitadas',
            },
            {
                Header: 'Horas Solicitadas',
                accessor: 'horasSolicitadas',
            },
            {
                Header: 'Estado',
                accessor: 'strEstadoPermiso',
            },
            {
                Header: 'Documentos',
                accessor: (row) => ({
                    ...row,
                    source: row.source  // Asegúrate de pasar la propiedad 'source' a la función
                }),
                Cell: ({ value }) => GenerarCellDocumentos(value)
            },
            {
                Header: 'Acciones',
                accessor: (row) => ({
                    ...row,
                    source: row.source  // Asegúrate de pasar la propiedad 'source' a la función
                }),
                Cell: ({ value }) => GenerarCellAcciones(value)
            }

            
        ], [dataprops, datapropsCH, datapropsL, datapropsV]
    )

    const columnasStyles = (cell): Array<CustomStyleColumn> => [
        {
            HeaderName: "Fecha Solicitud",
            StyleHeader: {
                textAlign: "center"
            }
        },
        {
            HeaderName: "Horas Solicitadas",
            StyleHeader: {
                textAlign: "center"
            }
        },
        {
            HeaderName: "Fecha Desde",
            StyleHeader: {
                textAlign: "center"
            }
        },
        {
            HeaderName: "Fecha Hasta",
            StyleHeader: {
                textAlign: "center"
            }
        },
        {
            HeaderName: "Horas",
            StyleHeader: {
                textAlign: "center"
            }
        },
        {
            HeaderName: "Días Solicitados",
            StyleHeader: {
                textAlign: "center"
            }
        },
        {
            HeaderName: "Estado",
            StyleHeader: {
                textAlign: "center"
            }
        },
        {
            HeaderName: "Documentos",
            StyleHeader: {
                textAlign: "center"
            }
        },
        {
            HeaderName: "Acciones",
            StyleHeader: {
                textAlign: "center"
            }
        },
    ]


    function ShowCheckBoxCondition(dataRow) {
        return dataRow;
    }

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        page,
        nextPage,
        previousPage,
        canNextPage,
        canPreviousPage,
        pageOptions,
        setPageSize,
        visibleColumns,
        prepareRow,
        state,
        setGlobalFilter
    } = useTable(
        {
            columns: columnas,
            data: filas
        },
        useGlobalFilter,
        useSortBy,
        usePagination
    )

    const { globalFilter, pageIndex, pageSize } = state;
    const sizerows = filas.length;

    return (
        <React.Fragment>
            <Row>
                <Col xl={12}>
                    <Table responsive {...getTableProps()} style={{ border: 'solid 1px ' }} className="tablesReact" >
                        <thead style={{}}>
                            {headerGroups.map(headerGroup => (
                                <tr {...headerGroup.getHeaderGroupProps()}>
                                    {headerGroup.headers.map(column => (
                                        <th
                                            {...column.getHeaderProps(column.getSortByToggleProps())}
                                            className='clickable'
                                        >
                                            {column.render('Header')}
                                            <span>
                                                {column.isSorted ? (column.isSortedDesc ? '⬆️' : '⬇️') : ''}
                                            </span>
                                        </th>
                                    ))}
                                </tr>
                            ))}
                        </thead>
                        <tbody {...getTableBodyProps()}>
                            {page.map((row, indirow) => {
                                prepareRow(row)
                                return (
                                    <tr {...row.getRowProps()}>

                                        {row.cells.map(cell => {
                                            return getTdTableStyles(cell, { border: 'solid 1px black' }, indirow, columnasStyles(cell))

                                        })}
                                    </tr>
                                )
                            })}
                        </tbody>
                    </Table>
                </Col>
            </Row>



        </React.Fragment>
    )
}


